import React from 'react'
import styled from '@emotion/styled'
import { BrowserUtils } from '../../../utils/siteUtils'
import { breakpoints } from '../../../constants'
import BasicButton from '../../generic/button'

const fireTradeComplete = (offer, markupAmount) => {
  BrowserUtils.clearLastPostMessage()
  const prospect = offer && offer && offer.prospect
  const now = new Date()
  const payload = prospect && {
    type: 'EXTERNAL_TRADE_COMPLETED',
    payload: {
      KBBVehicleId: prospect.vehicle.trimId,
      email: prospect.contactInfo.email,
      firstName: prospect.contactInfo.firstName,
      lastName: prospect.contactInfo.lastName,
      make: prospect.vehicle.vehicleDescription.make,
      markupAmount: markupAmount || 0,
      mileage: prospect.mileage,
      model: prospect.vehicle.vehicleDescription.model,
      offerDate: now.toISOString(),
      offerExpirationDate: offer.expirationDate,
      offerId: offer.offerId,
      phone: prospect.contactInfo.phone,
      status: offer.status,
      tivSource: 'ICO',
      trim: prospect.vehicle.vehicleDescription.trim,
      value: offer.amount,
      year: prospect.vehicle.vehicleDescription.year,
      zip: prospect.contactInfo.zip,
      vin: prospect.vehicle.vin || '',
      primaryBodyStyle: offer.primaryBodyStyle
    }
  }
  BrowserUtils.postMessage(JSON.stringify(payload), '*')
}

export default ({ dealerListUrl, isCleared, offer, markupAmount }) => {
  let buttonText = isCleared ? 'Add Instant Cash Offer' : 'Click here to return to your deal'
  buttonText += isCleared && markupAmount && markupAmount > 0 ? ' + Dealer Boost' : ''
  return (
    <>
      <StyledDiv isCleared={isCleared}>
        <BasicButton onClick={() => fireTradeComplete(offer, markupAmount)}>{buttonText}</BasicButton>
      </StyledDiv>
      <StyledDiv isCleared={isCleared}>{dealerListUrl && <BasicButton onClick={() => (window.location.href = dealerListUrl)}>See all local participating dealers</BasicButton>}</StyledDiv>
    </>
  )
}
const StyledDiv = styled.div`
  width: 100%;
  text-align: center;
  @media (min-width: ${breakpoints.lg}px) {
    ${p => p.isCleared && `text-align: right;`};
  }
`
